import React from 'react';

const CrossIconSvgV2 = ({ onClick, style }: { onClick?: () => void, style?: React.CSSProperties }) => {
  return (
    <svg style={style} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M12 4L4 12" stroke="white" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 4L12 12" stroke="white" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CrossIconSvgV2;
